export const getDealValidationKey = (dealId, property) => `${dealId}.${property}`;